import React, { useState, useEffect } from "react";
import "./checkin.css";
import Checkout from "./checkout";

const Icon = {
  dashboard: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M10 6V0H18V6H10ZM0 10V0H8V10H0ZM10 18V8H18V18H10ZM0 18V12H8V18H0ZM2 8H6V2H2V8ZM12 16H16V10H12V16ZM12 4H16V2H12V4ZM2 16H6V14H2V16Z" />
    </svg>
  ),

  vehicle: (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor">
      <path d="M3 14V15C3 15.2833 2.90417 15.5208 2.7125 15.7125C2.52083 15.9042 2.28333 16 2 16H1C0.716667 16 0.479167 15.9042 0.2875 15.7125C0.0958333 15.5208 0 15.2833 0 15V7L2.1 1C2.2 0.7 2.37917 0.458333 2.6375 0.275C2.89583 0.0916667 3.18333 0 3.5 0H14.5C14.8167 0 15.1042 0.0916667 15.3625 0.275C15.6208 0.458333 15.8 0.7 15.9 1L18 7V15C18 15.2833 17.9042 15.5208 17.7125 15.7125C17.5208 15.9042 17.2833 16 17 16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15V14H3ZM2.8 5H15.2L14.15 2H3.85L2.8 5ZM4.5 11C4.91667 11 5.27083 10.8542 5.5625 10.5625C5.85417 10.2708 6 9.91667 6 9.5C6 9.08333 5.85417 8.72917 5.5625 8.4375C5.27083 8.14583 4.91667 8 4.5 8C4.08333 8 3.72917 8.14583 3.4375 8.4375C3.14583 8.72917 3 9.08333 3 9.5C3 9.91667 3.14583 10.2708 3.4375 10.5625C3.72917 10.8542 4.08333 11 4.5 11ZM13.5 11C13.9167 11 14.2708 10.8542 14.5625 10.5625C14.8542 10.2708 15 9.91667 15 9.5C15 9.08333 14.8542 8.72917 14.5625 8.4375C14.2708 8.14583 13.9167 8 13.5 8C13.0833 8 12.7292 8.14583 12.4375 8.4375C12.1458 8.72917 12 9.08333 12 9.5C12 9.91667 12.1458 10.2708 12.4375 10.5625C12.7292 10.8542 13.0833 11 13.5 11ZM2 12H16V7H2V12Z" />
    </svg>
  ),

  checkin: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M8.55 17.1V15.2H15.2V1.9H8.55V0H15.2C15.7225 0 16.1698 0.186042 16.5419 0.558125C16.914 0.930208 17.1 1.3775 17.1 1.9V15.2C17.1 15.7225 16.914 16.1698 16.5419 16.5419C16.1698 16.914 15.7225 17.1 15.2 17.1H8.55ZM6.65 13.3L5.34375 11.9225L7.76625 9.5H0V7.6H7.76625L5.34375 5.1775L6.65 3.8L11.4 8.55L6.65 13.3Z" />
    </svg>
  ),

  checkout: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z" />
    </svg>
  ),

  analytics: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z" />
    </svg>
  ),

  settings: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="currentColor">
      <path d="M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375C2.55 10.2292 2.55 10.1167 2.55 10C2.55 9.88333 2.55 9.77083 2.55 9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625C17.55 9.77083 17.55 9.88333 17.55 10C17.55 10.1167 17.55 10.2292 17.55 10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z" />
    </svg>
  ),

  printer: (
  <svg
    width="25"
    height="23"
    viewBox="0 0 25 23"
    stroke="#303030"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 6.25V2.5H7.5V6.25H5V0H20V6.25H17.5ZM2.5 8.75C2.5 8.75 2.61979 8.75 2.85938 8.75C3.09896 8.75 3.39583 8.75 3.75 8.75H21.25C21.6042 8.75 21.901 8.75 22.1406 8.75C22.3802 8.75 22.5 8.75 22.5 8.75H20H5H2.5ZM20 11.875C20.3542 11.875 20.651 11.7552 20.8906 11.5156C21.1302 11.276 21.25 10.9792 21.25 10.625C21.25 10.2708 21.1302 9.97396 20.8906 9.73438C20.651 9.49479 20.3542 9.375 20 9.375C19.6458 9.375 19.349 9.49479 19.1094 9.73438C18.8698 9.97396 18.75 10.2708 18.75 10.625C18.75 10.9792 18.8698 11.276 19.1094 11.5156C19.349 11.7552 19.6458 11.875 20 11.875ZM17.5 20V15H7.5V20H17.5ZM20 22.5H5V17.5H0V10C0 8.9375 0.364583 8.04688 1.09375 7.32812C1.82292 6.60938 2.70833 6.25 3.75 6.25H21.25C22.3125 6.25 23.2031 6.60938 23.9219 7.32812C24.6406 8.04688 25 8.9375 25 10V17.5H20V22.5ZM22.5 15V10C22.5 9.64583 22.3802 9.34896 22.1406 9.10938C21.901 8.86979 21.6042 8.75 21.25 8.75H3.75C3.39583 8.75 3.09896 8.86979 2.85938 9.10938C2.61979 9.34896 2.5 9.64583 2.5 10V15H5V12.5H20V15H22.5Z"
      stroke="#303030"
    />
  </svg>
),
play: (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none">
    <path d="M0 17.5V0L13.75 8.75L0 17.5Z" fill="#F5F1FF" />
  </svg>
),

stop: (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M0 10V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196666 1.45067 0.000666667 2 0H10C10.55 0 11.021 0.196 11.413 0.588C11.805 0.98 12.0007 1.45067 12 2V10C12 10.55 11.8043 11.021 11.413 11.413C11.0217 11.805 10.5507 12.0007 10 12H2C1.45 12 0.979333 11.8043 0.588 11.413C0.196666 11.0217 0.000666667 10.5507 0 10Z" fill="#F5F1FF" />
  </svg>
),

  check: (
    <svg viewBox="0 0 24 24">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),

  close: (
    <svg viewBox="0 0 24 24">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
  activityCheckIn: (
  <svg width="11" height="13" viewBox="0 0 11 13" fill="none">
    <path
      d="M5.25 10.5V9.33333H9.33333V1.16667H5.25V0H9.33333C9.65417 0 9.92882 0.114236 10.1573 0.342708C10.3858 0.571181 10.5 0.845833 10.5 1.16667V9.33333C10.5 9.65417 10.3858 9.92882 10.1573 10.1573C9.92882 10.3858 9.65417 10.5 9.33333 10.5H5.25ZM4.08333 8.16667L3.28125 7.32083L4.76875 5.83333H0V4.66667H4.76875L3.28125 3.17917L4.08333 2.33333L7 5.25L4.08333 8.16667Z"
      fill="#2F1F96"
    />
  </svg>
),

activityPayment: (
  <svg width="13" height="10" viewBox="0 0 13 10" fill="none">
    <path
      d="M7.58333 5.25C7.09722 5.25 6.68403 5.07986 6.34375 4.73958C6.00347 4.39931 5.83333 3.98611 5.83333 3.5C5.83333 3.01389 6.00347 2.60069 6.34375 2.26042C6.68403 1.92014 7.09722 1.75 7.58333 1.75C8.06944 1.75 8.48264 1.92014 8.82292 2.26042C9.16319 2.60069 9.33333 3.01389 9.33333 3.5C9.33333 3.98611 9.16319 4.39931 8.82292 4.73958C8.48264 5.07986 8.06944 5.25 7.58333 5.25ZM3.5 7C3.17917 7 2.90451 6.88576 2.67604 6.65729C2.44757 6.42882 2.33333 6.15417 2.33333 5.83333V1.16667C2.33333 0.845833 2.44757 0.571181 2.67604 0.342708C2.90451 0.114236 3.17917 0 3.5 0H11.6667C11.9875 0 12.2622 0.114236 12.4906 0.342708C12.7191 0.571181 12.8333 0.845833 12.8333 1.16667V5.83333C12.8333 6.15417 12.7191 6.42882 12.4906 6.65729C12.2622 6.88576 11.9875 7 11.6667 7H3.5ZM4.66667 5.83333H10.5C10.5 5.5125 10.6142 5.23785 10.8427 5.00938C11.0712 4.7809 11.3458 4.66667 11.6667 4.66667V2.33333C11.3458 2.33333 11.0712 2.2191 10.8427 1.99063C10.6142 1.76215 10.5 1.4875 10.5 1.16667H4.66667C4.66667 1.4875 4.55243 1.76215 4.32396 1.99063C4.09549 2.2191 3.82083 2.33333 3.5 2.33333V4.66667C3.82083 4.66667 4.09549 4.7809 4.32396 5.00938C4.55243 5.23785 4.66667 5.5125 4.66667 5.83333ZM11.0833 9.33333H1.16667C0.845833 9.33333 0.571181 9.2191 0.342708 8.99063C0.114236 8.76215 0 8.4875 0 8.16667V1.75H1.16667V8.16667H11.0833V9.33333Z"
      fill="#2F1F96"
    />
  </svg>
),

activityCheckOut: (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
    <path
      d="M1.16667 10.5C0.845833 10.5 0.571181 10.3858 0.342708 10.1573C0.114236 9.92882 0 9.65417 0 9.33333V1.16667C0 0.845833 0.114236 0.571181 0.342708 0.342708C0.571181 0.114236 0.845833 0 1.16667 0H5.25V1.16667H1.16667V9.33333H5.25V10.5H1.16667ZM7.58333 8.16667L6.78125 7.32083L8.26875 5.83333H3.5V4.66667H8.26875L6.78125 3.17917L7.58333 2.33333L10.5 5.25L7.58333 8.16667Z"
      fill="#2F1F96"
    />
  </svg>
),
toastSuccess: (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path
      d="M14.5169 0C6.53262 0 0 6.53262 0 14.5169C0 22.5012 6.53262 29.0339 14.5169 29.0339C22.5012 29.0339 29.0339 22.5012 29.0339 14.5169C29.0339 6.53262 22.5012 0 14.5169 0ZM14.5169 26.1305C8.11497 26.1305 2.90339 20.9189 2.90339 14.5169C2.90339 8.11497 8.11497 2.90339 14.5169 2.90339C20.9189 2.90339 26.1305 8.11497 26.1305 14.5169C26.1305 20.9189 20.9189 26.1305 14.5169 26.1305ZM21.1802 8.10045L11.6135 17.6671L7.85366 13.9217L5.80677 15.9686L11.6135 21.7754L23.2271 10.1619L21.1802 8.10045Z"
      fill="#3523AB"
    />
  </svg>
),

toastError: (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none">
    <path
      d="M22.3199 12.521L12.521 22.3199M12.521 12.521L22.3199 22.3199"
      stroke="#FF1C1C"
      strokeWidth="3.26631"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4207 31.0303C24.937 31.0303 31.0303 24.937 31.0303 17.4207C31.0303 9.90427 24.937 3.81104 17.4207 3.81104C9.90427 3.81104 3.81104 9.90427 3.81104 17.4207C3.81104 24.937 9.90427 31.0303 17.4207 31.0303Z"
      stroke="#FF1C1C"
      strokeWidth="3.26631"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
),

toastPrint: (
  <svg width="25" height="23" viewBox="0 0 25 23" fill="none">
    <path
      d="M7.31508 22.3358C6.66956 22.3358 6.11743 22.1059 5.6587 21.6462C5.19997 21.1865 4.97011 20.6353 4.96915 19.9927V16.529H2.34448C1.69993 16.529 1.14829 16.2991 0.689554 15.8394C0.230819 15.3797 0.000967795 14.8281 0 14.1845V8.71161C0 7.88898 0.279209 7.19991 0.837627 6.6444C1.39604 6.08695 2.08463 5.80822 2.90339 5.80822H21.5518C22.3745 5.80822 23.064 6.08695 23.6205 6.6444C24.177 7.20185 24.4552 7.89092 24.4552 8.71161V14.1845C24.4552 14.829 24.2259 15.3807 23.7671 15.8394C23.3084 16.2982 22.7563 16.528 22.1107 16.529H19.4861V19.9913C19.4861 20.6358 19.2562 21.1875 18.7965 21.6462C18.3368 22.1049 17.7852 22.3348 17.1416 22.3358H7.31508ZM2.34448 15.0773H4.96915C5.00689 14.4647 5.24981 13.9392 5.6979 13.5007C6.14599 13.0633 6.68505 12.8446 7.31508 12.8446H17.1416C17.7707 12.8446 18.3092 13.0638 18.7573 13.5022C19.2054 13.9396 19.4483 14.4647 19.4861 15.0773H22.1107C22.3711 15.0773 22.585 14.9936 22.7524 14.8261C22.9198 14.6587 23.0035 14.4448 23.0035 14.1845V8.71161C23.0035 8.30127 22.8647 7.95673 22.5869 7.67801C22.3091 7.39928 21.9641 7.25992 21.5518 7.25992H2.90339C2.49207 7.25992 2.14754 7.39928 1.86978 7.67801C1.59202 7.95673 1.45266 8.30175 1.45169 8.71306V14.1845C1.45169 14.4448 1.53541 14.6587 1.70284 14.8261C1.87026 14.9936 2.08415 15.0773 2.34448 15.0773ZM18.0344 5.80968V2.34594C18.0344 2.08463 17.9507 1.87075 17.7832 1.70429C17.6158 1.53686 17.4019 1.45314 17.1416 1.45314H7.31363C7.05329 1.45314 6.83941 1.53686 6.67198 1.70429C6.50455 1.87172 6.42084 2.0856 6.42084 2.34594V5.80822H4.96915V2.34594C4.96915 1.70138 5.199 1.14926 5.6587 0.689555C6.11743 0.229852 6.66908 0 7.31363 0H17.1416C17.7861 0 18.3378 0.229852 18.7965 0.689555C19.2562 1.14926 19.4861 1.7009 19.4861 2.34448V5.80822L18.0344 5.80968ZM20.3803 10.8906C20.7916 10.8906 21.1362 10.7512 21.4139 10.4725C21.6917 10.1938 21.831 9.84925 21.832 9.43891C21.833 9.02856 21.6936 8.68355 21.4139 8.40385C21.1342 8.12416 20.7897 7.9848 20.3803 7.98576C19.9709 7.98673 19.6259 8.12609 19.3453 8.40385C19.0646 8.68161 18.9257 9.02663 18.9286 9.43891C18.9315 9.85119 19.0704 10.1957 19.3453 10.4725C19.6201 10.7493 19.9651 10.8887 20.3803 10.8906ZM18.0344 19.9898V15.1891C18.0344 14.9278 17.9507 14.7134 17.7832 14.546C17.6158 14.3785 17.4019 14.2948 17.1416 14.2948H7.31363C7.05329 14.2948 6.83941 14.3785 6.67198 14.546C6.50455 14.7144 6.42084 14.9287 6.42084 15.1891V19.9913C6.42084 20.2516 6.50455 20.4655 6.67198 20.6329C6.83941 20.8003 7.05378 20.8841 7.31508 20.8841H17.1416C17.4019 20.8841 17.6158 20.8003 17.7832 20.6329C17.9507 20.4655 18.0344 20.2511 18.0344 19.9898ZM2.34448 7.26137H1.45169H23.0035H2.34448Z"
      fill="#0C3F0D"
    />
  </svg>
),
  
};


function CheckIn({ setPage }) {
  const [tracking, setTracking] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [plate, setPlate] = useState("");
  const [model, setModel] = useState("");
  const [vehicleType, setVehicleType] = useState("Four Wheeler");
  const [toast, setToast] = useState(null);
  const [activeMenu, setActiveMenu] = useState("Check-In");
  const [showCheckout, setShowCheckout] = useState(false);

  const progress = Math.min((seconds / 15000) * 100, 100);

  useEffect(() => {
    let timer;
    if (tracking) {
      timer = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [tracking]);

  if (showCheckout) {
    return <Checkout setPage={setPage} />;
  }

  const formatTime = () => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const startTracking = () => {
    if (!plate || !model) {
      setToast({
        type: "error",
        title: "Check-In Unsuccessful",
        message: "The vehicle is not added",
      });
      setTimeout(() => setToast(null), 3000);
      return;
    }

    setTracking(true);
    setToast({
      type: "success",
      title: "Check-In Successful",
      message: "The vehicle is Successfully added",
    });

    setTimeout(() => setToast(null), 3000);
  };

  const stopTracking = () => {
    setTracking(false);
    setShowCheckout(true);
  };

  const printBill = () => {
    setToast({
      type: "print",
      title: "Bill Printing",
      message: "Print Job is Initiated",
    });

    setTimeout(() => setToast(null), 3000);
  };

  const cost = seconds > 0 ? 10 : 0;

  return (
    <div className="checkin-page">
      <aside className="sidebar">
        <nav>
          {[
            ["Dashboard", Icon.dashboard],
            ["Vehicles", Icon.vehicle],
            ["Check-In", Icon.checkin],
            ["Check-Out", Icon.checkout],
            ["Analytics", Icon.analytics],
            ["Settings", Icon.settings],
          ].map(([name, icon]) => (
            <div
  key={name}
  className={
    activeMenu === name ? "menu-item active" : "menu-item"
  }
  onClick={() => {
  if (name === "Dashboard") {
    setActiveMenu("Dashboard");
    setPage("dashboard");
  }

  if (name === "Vehicles") {
    setActiveMenu("Vehicles");
    setPage("vehicle");
  }

  if (name === "Check-In") {
    setActiveMenu("Check-In");
    // Already on Check-In page, so don't navigate again
  }

  if (name === "Check-Out") {

  }

  if (name === "Analytics") {
    setActiveMenu("Analytics");
    setPage("analytics");
  }

  if (name === "Settings") {
    setActiveMenu("Settings");
    setPage("settings");
  }
}}
>
  {icon}
  <span>{name}</span>
</div>
          ))}
          </nav>
           </aside>

      <main className="checkin-main">
        {toast && (
          <div className={`checkin-toast checkin-toast-${toast.type}`}>
            {toast.type === "error"
              ? Icon.toastError
              : toast.type === "print"
              ? Icon.toastPrint
              : Icon.toastSuccess}

            <div>
              <h4>{toast.title}</h4>
              <p>{toast.message}</p>
            </div>
          </div>
        )}

        <header className="checkin-header">
          <h1>Check-In Terminal</h1>
          <p>Luminous Building • Zone Alpha-9</p>
        </header>

        <section className="checkin-slot-section">
          <div className="checkin-slot-head">
            <span>SLOT AVAILABILITY</span>
            <span>TOTAL SLOTS: 60</span>
          </div>

          <div className="checkin-slot-bar">
            <div className="checkin-available">
              <span className="checkin-available-number">18</span>
              <span className="checkin-available-text">AVAILABLE</span>
            </div>

            <div className="checkin-occupied">42 OCCUPIED</div>
          </div>
        </section>

        <div className="checkin-content-grid">
          <section className="checkin-left-content">
            <div className="checkin-card">
              <div className="checkin-card-title">
                <span>01</span>
                <div>
                  <h2>Registration</h2>
                  <p>VEHICLE IDENTITY DETAILS</p>
                </div>
              </div>

              <div className="checkin-form-grid">
                <div>
                  <label>VEHICLE TYPE</label>
                  <div className="checkin-toggle">
                    <button
                      className={
                        vehicleType === "Four Wheeler"
                          ? "checkin-selected"
                          : ""
                      }
                      onClick={() => setVehicleType("Four Wheeler")}
                    >
                      Four Wheeler
                    </button>

                    <button
                      className={
                        vehicleType === "Two Wheeler"
                          ? "checkin-selected"
                          : ""
                      }
                      onClick={() => setVehicleType("Two Wheeler")}
                    >
                      Two Wheeler
                    </button>
                  </div>
                </div>

                <div>
                  <label>LICENSE PLATE NUMBER</label>
                  <div className="checkin-input-icon">
                    <span>#</span>
                    <input
                      placeholder="e.g. TN-68-AH2154"
                      value={plate}
                      onChange={(e) => setPlate(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label>VEHICLE MODEL</label>
                  <input
                    placeholder="Enter Vehicle model number"
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="checkin-card">
              <div className="checkin-card-title">
                <span>02</span>
                <div>
                  <h2>Tariffs</h2>
                  <p>BILLING & TIMING PARAMETERS</p>
                </div>
              </div>

              <div className="checkin-tariff-grid">
                <div>
                  <label>BILL NUMBER</label>
                  <p>#INV-99021</p>
                </div>

                <div>
                  <label>ARRIVAL DATE</label>
                  <p>May 24, 2024</p>
                </div>

                <div>
                  <label>ENTRY TIME</label>
                  <p>14:35 PM</p>
                </div>

                <div>
                  <label>PRICE SLAB</label>
                  <p>Premium Hourly</p>
                </div>
              </div>
            </div>

            <button
              className={
                tracking
                  ? "checkin-track-btn checkin-track-stop"
                  : "checkin-track-btn"
              }
              onClick={tracking ? stopTracking : startTracking}
            >
              {tracking ? Icon.stop : Icon.play}
{tracking ? "STOP TRACKING" : "START TRACKING"}
            </button>
          </section>

          <section className="checkin-timer-card">
            <div className="checkin-card-title">
              <span>03</span>
              <div>
                <h2>Check Timer</h2>
                <p>SESSION MONITORING</p>
              </div>
            </div>

            <div
              className="checkin-circle"
              style={{
                "--progress": progress,
              }}
            >
              {tracking && <div className="checkin-timer-dot"></div>}

              <div className="checkin-circle-inner">
                <h1>{formatTime()}</h1>
                <p>TOTAL DURATION</p>
              </div>
            </div>

            <label>TOTAL DURATION</label>
            <div className="checkin-info-box">
              {Math.floor(seconds / 3600)} Hrs :{" "}
              {Math.floor((seconds % 3600) / 60)} Min : {seconds % 60} sec
            </div>

            <label>TOTAL COST</label>
            <div className="checkin-info-box">₹ {cost}</div>
          </section>

          <section className="checkin-activity-card">
            <h3 className="checkin-activity-title">Recent Activity</h3>

            {[
              ["Check-In Processed", "Plate: KLP-8842", "02:22 PM"],
              ["Payment Processed", "Ticket #99401 - ₹24.50", "02:18 PM"],
              ["Check-Out Processed", "Plate: LUX-0012", "02:05 PM"],
              ["Check-In Processed", "Plate: KLP-8842", "14:22 PM"],
              ["Payment Processed", "Ticket #99401 - ₹24.50", "02:18 PM"],
            ].map((item, index) => (
              <div className="checkin-activity" key={index}>
                <div className="checkin-activity-icon">
                  {item[0].includes("Check-In")
                    ? Icon.activityCheckIn
                    : item[0].includes("Payment")
                    ? Icon.activityPayment
                    : Icon.activityCheckOut}
                </div>

                <div>
                  <h4>{item[0]}</h4>
                  <p>{item[1]}</p>
                </div>

                <span>{item[2]}</span>
              </div>
            ))}
          </section>
        </div>

        <div className="checkin-bottom-actions-check">
          <button onClick={printBill}>{Icon.printer}</button>

          <button
            onClick={() => {
              setPlate("");
              setModel("");
              setSeconds(0);
              setTracking(false);
            }}
          >
            + Add Another
          </button>
        </div>
      </main>
    </div>
  );
}

export default CheckIn;